import { FAILURE, REQUEST, SUCCESS } from 'lib/const'
import gbk from 'lib/gbk2'
import set from 'lodash/fp/set'

export const Cache = {
  get: (key) => {
    if (!window.sessionStorage) {return false}
    return JSON.parse(window.sessionStorage.getItem(key))
  },
  set: (key, data) => {
    if (!window.sessionStorage) {return false}
    window.sessionStorage.setItem(key, JSON.stringify(data))
    return true
  },
  has: (key) => Boolean(window.sessionStorage && window.sessionStorage.hasOwnProperty(key)),
  clear: () => {
    if (!window.sessionStorage) {return false}
    window.sessionStorage.clear()
  },
  del: (key) => {
    if (!window.sessionStorage) {return false}
    window.sessionStorage.removeItem(key)
  }
}
export const LocalCache = {
  get: (key) => {
    if (!window.localStorage) {return false}
    return JSON.parse(window.localStorage.getItem(key))
  },
  set: (key, data) => {
    if (!window.localStorage) {return false}
    window.localStorage.setItem(key, JSON.stringify(data))
    return true
  },
  has: (key) => Boolean(window.localStorage && window.localStorage.hasOwnProperty(key)),
  clear: () => {
    if (!window.localStorage) {return false}
    window.localStorage.clear()
  },
  del: (key) => {
    if (!window.localStorage) {return false}
    window.localStorage.removeItem(key)
  }
}

export function getQuery (para) {
  var reg = new RegExp('(^|&)' + para + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

export function isWeiXin () {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return true
  } else {
    return false
  }
  // 使用这里的
}

export function isEmptyObject (obj) {
  for (let o in obj) {
    if (obj.hasOwnProperty(o)) {
      return false
    }
  }
  return true
}

export function round (num, len) {
  return Math.round(num * Math.pow(10, len)) / Math.pow(10, len)
}

export function wxShare (title, link, imgUrl, desc, callBack) {
  console.log('查看微信配置', wx)
  wx.onMenuShareTimeline({
    title: title, // 分享标题
    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imgUrl, // 分享图标
    success: function () {
      // 用户确认分享后执行的回调函数
      callBack && callBack()
    },
    cancel: function () {
      // 用户取消分享后执行的回调函数
    }
  })
  wx.onMenuShareAppMessage({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imgUrl, // 分享图标
    type: '', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    success: function () {
      // 用户确认分享后执行的回调函数
      callBack && callBack()
    },
    cancel: function () {
      // 用户取消分享后执行的回调函数
    }
  })
}

export function noop () {}

export function margeMutations (actions) {
  let keys = Object.keys(actions)
  let mutations = {}
  let [success, failure, request] = [SUCCESS.toLowerCase(), FAILURE.toLowerCase(), REQUEST.toLowerCase()]
  keys.length && keys.forEach((actionName) => {
    mutations[`${actionName}_${success}`] = function (state, {refs}) {

    }
    mutations[`${actionName}_${request}`] = function (state, {refs}) {

    }
    mutations[`${actionName}_${failure}`] = function (state, {error}) {

    }
  })
  return mutations
}

export function hexToStr (str) {
  str = str.replace(/\s/g, '').replace(/(\w{2})/g, '%$1').replace(/\%ff/g, '').replace(/\%00/g, '')
  return decodeURIComponent(gbk.URI.decodeURIComponent(str).replace(/￿/g, ' '))
}


export function hexToUTF8Str (str) {
  str = str.replace(/\s/g, '').replace(/(\w{2})/g, '%$1').replace(/\%ff/g, '')
  return decodeURI(str)
}

export function strToHex (str) {
  if (str === '') {
    return ''
  }
  var hexCharCode = []
  for (var i = 0; i < str.length; i++) {
    hexCharCode.push((str.charCodeAt(i)).toString(16))
  }
  return hexCharCode.join('')
}

export function isFun (fun) {
  return Object.prototype.toString.call(fun) === '[object Function]'
}

export function isObj (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export function numToHex (num) {
  if (num > 0 && num < 10000) {
    return num.toString(16).padStart(4, 0).match(/\S{2}/g).reverse().join('')
  } else {
    throw new Error('解析的数字在1~9999之间')
  }

}
